import moment from 'moment'

/**
 * Lex meeting_time values are Eastern wall-clock datetimes stored in
 * timestamp-without-time-zone. Backends sometimes append "Z", which makes
 * local moment() shift the clock (e.g. 8:00 PM -> 4:00 PM in EDT).
 *
 * Always format the date/time digits as written — never apply a timezone offset.
 */
export function lexMoment(meetingTime) {
  if (meetingTime == null || meetingTime === '') {
    return moment.invalid()
  }

  if (typeof meetingTime === 'string') {
    const naive = meetingTime
      .trim()
      .replace(/Z$/i, '')
      .replace(/[+-]\d{2}:?\d{2}$/, '')
      .replace('T', ' ')
    const parsed = moment.utc(
      naive,
      ['YYYY-MM-DD HH:mm:ss.SSS', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'],
      true
    )
    if (parsed.isValid()) return parsed
  }

  return moment.utc(meetingTime)
}

export function formatLexTime(meetingTime, format = 'h:mm A') {
  return lexMoment(meetingTime).format(format)
}

export default lexMoment
